import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import AppleOutlinedSvg from "@ant-design/icons-svg/es/asn/AppleOutlined";
import AntdIcon from '../components/AntdIcon';
var AppleOutlined = function AppleOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: AppleOutlinedSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(AppleOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'AppleOutlined';
}
export default RefIcon;